import React from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import HomepageProductsBlockData from 'Models/Content/HomepageProductsBlockData';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {Container} from 'reactstrap';

const HomepageProductsBlock = ({data, context}: ComponentProps<HomepageProductsBlockData>) => {
  return (
    <Container>
      <div className='HomepageProductsBlock'>
        <ContentArea noWrap context={context} data={data.lItems} />
      </div>
    </Container>
  );
};

export default HomepageProductsBlock;
